import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import ProcessComponent from "../ProcessComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchMinus } from "@fortawesome/free-solid-svg-icons";
import DropDown from "../DropDown";
import { labeledActiveFilters } from "../../../services/FilteringUtils";
import { labels } from "../../../localization/labels";
import { Input } from "antd";
import SubmitButton from "../SubmitButton/SubmitButton";
import CommonUtil from "../../../utils/CommonUtil";
import SubmitControl from "../SubmitControl/SubmitControl";

const { Search } = Input;

const ComponentHeader = ({
  title,
  id,
  addProcesses,
  onAdd,
  deleteProcesses,
  onDelete,
  advancedSearchParametersExist,
  onAdvancedSearch,
  onAdvancedSearchDelete,
  activeFilter,
  activeProcesses,
  onActiveFilterChange,
  onSearchChange,
  searchValue,
  showBackButton
}) => {
  return (
    <div className="tableHeader d-flex align-items-center">
      <Row
        className="tableHeaderRow d-flex flex-grow-1"
        style={{ marginRight: 0 }}
        noGutters
      >
        {title ? (
          <div className="d-flex align-items-center">
            <Col className="tableLabel">
              <div className="d-flex align-items-center">
                {showBackButton && window.history.length > 1 ? (
                  <SubmitButton
                    type="back"
                    className="headerBackButton"
                    transparent
                  />
                ) : null}{" "}
                <div>{CommonUtil.constructHeaderTitleAndId(title, id)}</div>
              </div>
            </Col>{" "}
          </div>
        ) : null}

        <Col className="flex-grow-1" sm={{ span: "auto" }} xs="12">
          {onSearchChange ? (
            <SubmitControl
              disableable={false}
              type="search"
              placeholder={labels.search}
              onChange={onSearchChange}
              value={searchValue}
            />
          ) : null}
        </Col>

        <Col className="tableButtons flex-grow-0" sm={{ span: "auto" }} xs="12">
          {onAdd ? (
            <SubmitButton
              type="create"
              onClick={onAdd}
              processes={addProcesses}
            />
          ) : null}
          {onDelete && activeFilter !== labeledActiveFilters[1] ? (
            <SubmitButton
              type="delete"
              onClick={onDelete}
              text={labels.deleteButtonDescription}
              processes={deleteProcesses}
              showLoader={false}
            />
          ) : null}
          {onAdvancedSearch ? (
            <SubmitButton
              type="search"
              onClick={onAdvancedSearch}
              text={labels.advancedSearch}
            />
          ) : null}
          {advancedSearchParametersExist && onAdvancedSearchDelete ? (
            <Button
              className="buttonStyle"
              title={labels.advancedSearchParamsDelete}
              onClick={onAdvancedSearchDelete}
            >
              <FontAwesomeIcon icon={faSearchMinus} />
            </Button>
          ) : null}
        </Col>

        {onActiveFilterChange ? (
          <ProcessComponent processes={activeProcesses}>
            <Col
              className="flex-grow-0"
              lg="2"
              md="3"
              sm="3"
              xl="3"
              xs="12"
              style={{ paddingRight: 0 }}
            >
              <DropDown
                value={activeFilter}
                options={labeledActiveFilters.map(x => ({
                  value: x,
                  label: x.label
                }))}
                onChange={onActiveFilterChange}
                processes={activeProcesses}
              />
            </Col>
          </ProcessComponent>
        ) : null}
      </Row>
    </div>
  );
};

export default ComponentHeader;
